export const FETCH_USER = 'FETCH_USER';



// WEBPACK FOOTER //
// ./src/actions/types.js